import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — the gable roof segment: two sloped panes meeting at a ridge
// 0.8 above the eaves, ridge running along X. The panes span the full 1 m
// tile in both axes so consecutive tiles chain into a continuous roof.
// Authored with eaves at y=0; the consumer lifts it onto 2.6 m walls.
const SHINGLE = "#4a4a4e";
const RIDGE = "#5a5a5e";

// Slope: rises 0.8 over a 0.5 m half-tile run.
const RISE = 0.8;
const RUN = 0.5;
const PITCH = Math.atan2(RISE, RUN);
const PANE_LEN = Math.hypot(RISE, RUN);

export const roofGable = defineModel({
  id: "roof-gable",
  batchId: "modern",
  name: "Gable roof",
  tags: ["modern", "outdoor", "structure", "roof"],
  summary: "A 1x1 gable roof segment, ridge along X, 0.8 rise.",
  description:
    "The gable roof segment of the Modern Living kit: two shingle panes " +
    "meeting at a ridge 0.8 m above the eaves, ridge along X, spanning the " +
    "full 1 m tile so tiles chain into a continuous roof. Eaves at y=0; " +
    "the consumer lifts it onto 2.6 m walls.",
  tiles: { w: 1, h: 1 },
  footprint: 0.9,
  parts(): Part[] {
    return [
      // South pane (slopes down toward +Z), from ridge (y=0.8, z=0) to eave (y=0, z=0.5).
      { geometry: new THREE.BoxGeometry(1.0, 0.06, PANE_LEN), color: SHINGLE,
        position: [0, RISE / 2, RUN / 2], rotation: [PITCH, 0, 0] },
      // North pane (slopes down toward -Z).
      { geometry: new THREE.BoxGeometry(1.0, 0.06, PANE_LEN), color: SHINGLE,
        position: [0, RISE / 2, -RUN / 2], rotation: [-PITCH, 0, 0] },
      // Ridge cap.
      { geometry: new THREE.BoxGeometry(1.0, 0.05, 0.14), color: RIDGE, position: [0, RISE + 0.02, 0] },
    ];
  },
  animations: [],
});
